import { render, staticRenderFns } from "./UploadInput.vue?vue&type=template&id=457a7312"
import script from "./UploadInput.vue?vue&type=script&lang=js"
export * from "./UploadInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports